import Link from "next/link";

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center">
        <div className="mb-4 md:mb-0">
          <span className="text-lg font-bold">WTC Hub</span>
          <p className="text-gray-400 text-sm mt-1">
            &copy; {new Date().getFullYear()} West Tennessee Consulting. All rights reserved.
          </p>
        </div>
        <div className="flex gap-6 text-sm text-gray-400">
          <Link href="https://westtn.consulting/en/privacy" className="hover:text-white">
            Privacy Policy
          </Link>
          <Link href="https://westtn.consulting/en/terms" className="hover:text-white">
            Terms of Service
          </Link>
          <a href="mailto:info@westtn.consulting" className="hover:text-white">
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}
